import noop from "lodash/noop";
import { useState, useEffect, useCallback } from "react";

import {
  EventDescriptionFieldProps,
  UseDescriptionFieldReturnType,
} from "./types";

export const useDescriptionField = ({
  onChange = noop,
  value = "",
}: EventDescriptionFieldProps): UseDescriptionFieldReturnType => {
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [description, setDescription] = useState<string>(value);

  useEffect(() => {
    setDescription(value);
  }, [value]);

  return {
    onModalConfirm: useCallback(() => {
      onChange(description);
      setShowDescriptionModal(false);
    }, [description, onChange]),
    onModalCancel: useCallback(() => {
      setDescription(value);
      setShowDescriptionModal(false);
    }, [value]),
    openModal: useCallback(() => {
      setShowDescriptionModal(true);
    }, []),
    onDescriptionChange: setDescription,
    description,
    showDescriptionModal,
  };
};
